<template>
  <Layout
    v-if="isValid"
    class="AreaOfInterestView"
    :key="keySlug"
    :heading-text="layoutHeadingText"
    :subheading-text="layoutSubheadingText"
  >
    <!-- Single Subject Area Header -->
    <SubjectAreaHeader
      v-if="useSALayout"
      :post-obj="postObj"
      :heading-text="headingText"
    />
    <!-- Lists -->
    <SubjectAreas
      v-if="isSubjectAreaParent"
      :list="list"
      class=""
    />
    <CardList
      v-else-if="!isSubjectAreaParent && usedArr( list )"
      :list="list"
      :left-align="useSALayout"
    />
    <JustExplorePrompt v-if="!mainMenuEnabled && isAoiMenu"/>
    <LiveEventsPrompt class="md:hidden" />
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import SubjectAreaHeader from '@/components/SubjectAreaHeader.vue'
import SubjectAreas from '@/components/SubjectAreas.vue'
import CardList from '@/components/CardList.vue'
import JustExplorePrompt from '@/components/JustExplorePrompt.vue'
import LiveEventsPrompt from '@/components/LiveEventsPrompt.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'AreaOfInterest',

  components: {
    Layout,
    SubjectAreaHeader,
    SubjectAreas,
    CardList,
    JustExplorePrompt,
    LiveEventsPrompt
  },

  computed: {
    ...mapState([
      'settings'
    ]),
    ...mapGetters([
      'mainMenuEnabled',
      'topLevelAoi',
      'aoiPage',
      'justExplorePage',
      'routeAoi',
    ]),
    isAoiPost() { return (this.$route.params || {}).aoi_id },
    isAoiMenu() { return !this.isAoiPost },
    postObj() { return (this.isAoiPost ? this.routeAoi : this.aoiPage) || {} },
    keySlug() { return this.isAoiPost ? `aoi-${(this.routeAoi || {}).slug}` : 'aoi-page' },
    isSubjectAreaParent() { return this.postObj.is_sa_parent },
    useSALayout() {
      const { body, main_cta, featuredContent, mainVideo, isSubjectArea } = this.postObj
      const saBodyValid = body && body.length
      const saCtaValid = main_cta && main_cta.url && main_cta.text
      const saFeaturedContentValid = featuredContent
      const saVideoValid = mainVideo
      const hasFeaturedContent = saFeaturedContentValid || saVideoValid
      const showSubjectHeader = saBodyValid || saCtaValid || hasFeaturedContent
      return isSubjectArea && showSubjectHeader && true
    },
    // Page Content
    headingText() { return (this.postObj.heading_text || this.postObj.title) ?? '' },
    layoutHeadingText() { return this.useSALayout ? '' : this.headingText },
    subheadingText() { return this.postObj.subheading_text ?? '' },
    layoutSubheadingText() { return this.useSALayout ? '' : this.subheadingText },
    list() {
      const isAoiPost = !this.isAoiPost
      const aoiChildren = this.isAoiPost && (this.routeAoi || {}).children
      const listArr = (isAoiPost ? this.topLevelAoi : aoiChildren) || []
      return listArr.map((item) => {
        // Has URL
        const hasUrl = item.url ?? false
        if (hasUrl) { return item }
        // Route
        const routeTo = { params: {} }
        const isMedia = ['group', 'panorama', 'gallery', 'video', 'article'].includes(item.type)
        const isGroupPano = item.type === 'group'
        const isSinglePano = item.type === 'panorama'
        // Route name
        routeTo.name = (isGroupPano || isSinglePano) ? 'aoi-panorama' : isMedia ? 'aoi-media' : 'aoi-sublevel'
        // Params
        if (!isMedia) {
          routeTo.params.aoi_id = item.slug
        } else {
          routeTo.params.media_id = isSinglePano ? 'single' : item.slug
          routeTo.params.panorama_id = isSinglePano ? item.slug : (item.children[0] || {}).slug
        }
        // Return
        item.routeTo = routeTo
        return item
      })
    },
    // Valid
    isValid() {
      const { postObj } = this
      const { slug } = postObj
      return slug
    },
  },

  watch: {
    headingText() { this.updatePageMeta() }
  },

  beforeMount() {
    this.updatePageMeta()
  },

  mounted() {
    this.updatePageMeta()
  },

  methods: {
    updatePageMeta() {
      const postParentTitle = ((this.postObj || {}).parent || {}).title
      this.$store.commit('pageMeta', {
        pageTitle: this.headingText,
        parentTitle: this.isAoiPost && (postParentTitle || this.aoiPage.title)
      })
    }
  }
}
</script>

